import {Component, input, ChangeDetectionStrategy} from '@angular/core';

/**
 * Значок «открыть во внешней ссылке» — квадрат с косой стрелкой.
 * Показывается у материалов с внешним источником (news.link), цвет — currentColor.
 */
@Component({
    selector: 'app-ext-link-icon',
    template: `
    <svg
      [attr.width]="size()" [attr.height]="size()"
      viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round"
      aria-hidden="true" class="ext-link-icon">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
      <polyline points="15 3 21 3 21 9"/>
      <line x1="10" y1="14" x2="21" y2="3"/>
    </svg>`,
    styles: `
    :host {
      display: inline-flex;
      align-items: center;
      vertical-align: baseline;
      margin-left: 4px;
      opacity: 0.7;
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ExtLinkIconComponent {
  size = input<number>(14);
}
